'use strict';

module.exports = '3.35.1';



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/node_modules/algoliasearch/src/version.js
// module id = 491
// module chunks = 0